import React from 'react'
import Home from '../Components/UserHome/Home'

function UserHome() {
    return (
        <div>
            <Home />
        </div>
    )
}

export default UserHome
